import { EnumScreenName } from '@calm/evexia-analytics';
import useAccount from '@rhg/hooks/use-account';
import { useActiveCircle } from '@rhg/hooks/use-active-circle';
import { useCallback } from 'react';
import useAnalyticsStreamEvents, {
    DataWarehouseEventData,
} from '../use-analytics-stream-events';

interface TrackDataWarehouseEventType {
    screenName: EnumScreenName;
    actionName?: string;
}

export default function useDataWarehouseEvent() {
    const { activeCircle } = useActiveCircle();
    const { account } = useAccount();
    const { trackAnalyticsStreamEvent } = useAnalyticsStreamEvents();

    const trackDataWarehouseEvent = useCallback(
        ({
            actionName = 'screen_viewed',
            screenName,
        }: TrackDataWarehouseEventType) => {
            if (!activeCircle?.authorizationJWT) return;

            const data: DataWarehouseEventData = {
                action: actionName,
                user_id: activeCircle?.recipient?.userId || '',
                recipient_id: activeCircle?.recipient.id || '',
                analytics_id: account?.analyticsId || '',
                screen_name: screenName,
            };

            trackAnalyticsStreamEvent({
                requestData: data,
                eventName: 'app_events',
            });
        },
        [
            account?.analyticsId,
            activeCircle?.authorizationJWT,
            activeCircle?.recipient.id,
            activeCircle?.recipient?.userId,
            trackAnalyticsStreamEvent,
        ]
    );

    return {
        trackDataWarehouseEvent,
    };
}
